// Przycisk "wstecz" w nagłówku, obok loga - wygodniejszy niż szukanie strzałki przeglądarki,
// zwłaszcza na telefonie. history.length > 1 jako przybliżony sygnał "jest dokąd wracać w tej
// karcie" - przy wejściu wprost (nowa karta/link z zewnątrz) history.back() byłoby martwym
// kliknięciem, więc wtedy zamiast tego wracamy na stronę główną.
const backBtn = document.getElementById("site-back-btn");
if (backBtn) {
    backBtn.addEventListener("click", () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = "/";
        }
    });
}

// Rozwijane menu nagłówka (FAQ/Kontakt/Regulamin) schowane za jednym przyciskiem - ten sam
// panel na każdej szerokości ekranu, patrz .site-menu-panel w style.css.
const menuToggle = document.getElementById("site-menu-toggle");
const menuPanel = document.getElementById("site-menu-panel");

if (menuToggle && menuPanel) {
    const toggle = menuToggle;
    const panel = menuPanel;

    const closeMenu = (): void => {
        panel.classList.remove("open");
        toggle.setAttribute("aria-expanded", "false");
    };

    toggle.addEventListener("click", (event) => {
        event.stopPropagation();
        const isOpen = panel.classList.toggle("open");
        toggle.setAttribute("aria-expanded", String(isOpen));
    });

    // Klik gdziekolwiek poza panelem (albo na jednym z linków w nim) zamyka menu - inaczej
    // zostawałoby otwarte po przejściu na inną stronę / kliknięciu w treść pod spodem.
    document.addEventListener("click", (event) => {
        if (!panel.contains(event.target as Node) && event.target !== toggle) {
            closeMenu();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeMenu();
    });
}

// Przełącznik motywu kolorystycznego w menu - patrz [data-theme] w style.css i skrypt w <head>
// base.html, który nakłada zapamiętany wybór przed pierwszym malowaniem.
const THEME_STORAGE_KEY = "mp-theme";
const themeSwatches = Array.from(document.querySelectorAll<HTMLButtonElement>(".theme-swatch"));

const markActiveTheme = (theme: string): void => {
    for (const swatch of themeSwatches) {
        swatch.setAttribute("aria-pressed", String((swatch.dataset.themeChoice ?? "") === theme));
    }
};

markActiveTheme(document.documentElement.getAttribute("data-theme") ?? "");

for (const swatch of themeSwatches) {
    swatch.addEventListener("click", (event) => {
        // Bez zamykania menu - można szybko przeklikać kilka motywów i porównać.
        event.stopPropagation();
        const theme = swatch.dataset.themeChoice ?? "";
        if (theme) {
            document.documentElement.setAttribute("data-theme", theme);
        } else {
            document.documentElement.removeAttribute("data-theme");
        }
        try {
            if (theme) localStorage.setItem(THEME_STORAGE_KEY, theme);
            else localStorage.removeItem(THEME_STORAGE_KEY);
        } catch {
            // Tryb prywatny / zablokowane dane strony - motyw działa do końca wizyty.
        }
        markActiveTheme(theme);
    });
}
